module.exports = __webpack_public_path__ + "static/media/27.be461fb7.mp3";